import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";

import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { LoggerService } from "@core/services/logger.service";

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      logger.error("HTTP error occurred:", error);

      return throwError(() => error);
    })
  );
};
